export default class extends HTMLElement {
  connectedCallback () {
    this.clearChecked()

    this.addEventListener('click', (e) => {
      e.stopPropagation()

      const text = this.dataset.text || this.innerText.trim()

      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
          .then(() => this.showToast())
          .catch(() => {
            // no-op: keep silent to avoid noisy alerts on failure
          })
      } else {
        if (e.target.tagName !== 'INPUT') {
          alert(`Clipboard not available. Make sure you're using https://\nCopy text: ${text}`)
        }
      }
    })
  }

  clearChecked () {
    this.querySelectorAll('input').forEach((e) => {
      e.checked = false
    })
  }

  showToast () {
    // Look for a nearby toast element explicitly marked for clipboard
    const container = this.parentElement || document
    const toast = container.querySelector('[data-clipboard-toast]')
    if (!toast) return

    // Optional message span inside toast
    const message = toast.querySelector('[data-toast-message]')
    if (message && !message.textContent?.trim()) {
      message.textContent = 'Copied to clipboard'
    }

    // Show toast briefly
    toast.style.display = 'block'
    toast.classList.add('toast-center')

    window.clearTimeout(this._toastTimer)
    this._toastTimer = window.setTimeout(() => {
      toast.style.display = 'none'
      toast.classList.remove('toast-center')
    }, 3000)
  }
}
